module.exports = __webpack_public_path__ + "static/media/novarc-logo.black.96903df1.svg";